import React from 'react';

export const name = 'flag-BG';

export const FlagBG = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2_57)">
      <mask
        id="mask0_2_57"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2_57)">
        <path
          d="M24 12C24 10.5328 23.7375 9.12657 23.25 7.82813L12 7.30313L0.750006 7.82813C-0.250124 10.5195 -0.250124 13.4806 0.750006 16.1719L12 16.6969L23.25 16.1719C23.7375 14.8734 24 13.4672 24 12Z"
          fill="#496E2D"
        />
        <path
          d="M12 24C14.4501 23.9997 16.8414 23.2494 18.8525 21.85C20.8636 20.4506 22.3982 18.4691 23.25 16.1719H0.75C1.60179 18.4691 3.13636 20.4506 5.14748 21.85C7.15861 23.2494 9.54989 23.9997 12 24Z"
          fill="#D80027"
        />
        <path
          d="M0.75 7.82812H23.25C22.3976 5.53158 20.8627 3.55095 18.8516 2.15229C16.8406 0.753628 14.4496 0.00393677 12 0.00393677C9.55036 0.00393677 7.15941 0.753628 5.14838 2.15229C3.13728 3.55095 1.60243 5.53158 0.75 7.82812Z"
          fill="#EEEEEE"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2_57">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
